import styles from './Card.scss';

import cx from 'classnames';
import React from 'react';

import { ReferencedEntry } from 'contentful';
import { Topic } from 'src/api/contentful/contentTypes.cloverdotcom';

import { useResponsive } from 'src/components/Responsive/Responsive';
import { DisplayMode, EnhancedMedia } from '../EnhancedMedia/EnhancedMedia';
import { MediaProps } from '../Media/Media';

export interface ICardProps extends React.AllHTMLAttributes<HTMLElement> {
  entry?: ReferencedEntry<Topic>;
  mediaClassName?: string;
  captionClassName?: string;
  forceImage?: boolean;
  enhancedMediaRef?: React.Ref<EnhancedMedia>;
  mediaProps?: Pick<MediaProps, Exclude<keyof MediaProps, 'image' | 'video' | 'autoHeight' | 'autoWidth'>>;
  backgroundColor?: string;
}

export const Card = React.forwardRef<HTMLDivElement, ICardProps>(({
  entry, className, mediaClassName, captionClassName, enhancedMediaRef, children, mediaProps, preload, forceImage, backgroundColor, ...props
}, ref) => {
  const { browser } = useResponsive();
  const isTablet = browser.is.tablet;

  if (!entry || !entry.fields) return null;

  const { video } = entry.fields;

  return (
    <div className={cx(className, styles.card)} ref={ref} style={{ backgroundColor }} {...props}>
      <EnhancedMedia
        ref={enhancedMediaRef}
        autoPlay
        muted
        loop
        className={cx(styles.mediaWrapper, mediaClassName)}
        preferHeight={!!video && isTablet}
        preferWidth={(!!video && !isTablet) || forceImage || !video}
        entry={entry}
        disableFrame
        displayMode={forceImage ? DisplayMode.IMAGE_ONLY : DisplayMode.AUTO}
        preload={preload}
        mediaProps={mediaProps}
      />
      {React.Children.count(children) > 0 && (
        <div className={cx(styles.captionWrapper, captionClassName)}>
          {children}
        </div>
      )}
    </div>
  );
});
